import React from "react";
import { useSyncExternalStore } from "react";
import { useAppContext } from "../Universal/API/Context-API/AppContext";
import { useUserState } from "../Universal/API/Context-API/hooks/useUserState";
import { getCurrentRouteSnapshot, rootReplace, subscribeRouteSnapshot } from "../Navigator/navigationRef";
import { useCart } from "../Universal/API/Context-API/CartContext";
import CartHistoryFloatingPanel from "./Components/CartHistoryFloatingPanel";

const normalizeHistoryFlag = (value: unknown) =>
  value === true || value === "1" || value === "true";

const CartHistoryFloatingHost: React.FC = () => {
  const routeSnapshot = useSyncExternalStore(subscribeRouteSnapshot, getCurrentRouteSnapshot);
  const { isSmallVersion, scaleAll } = useAppContext();
  const userState = useUserState();
  const {
    uniqueItemsCount,
    totalQuantity,
    subtotal,
    discountedSubtotal,
    historyOrders,
  } = useCart();

  const isCartRoute = routeSnapshot.name === "Cart";
  const isVisible = isCartRoute && userState.isUserLoggedIn && !isSmallVersion;
  const routeParams = routeSnapshot.params ?? null;
  const isHistoryMode = normalizeHistoryFlag(routeParams?.history);
  const selectedOrderId =
    typeof routeParams?.orderId === "string" && routeParams.orderId.trim().length > 0
      ? routeParams.orderId.trim()
      : null;
  const showDiscountPrices = userState.isUserLoogedInAndShowDiscountPrices;
  const currentOrderTotal = showDiscountPrices ? discountedSubtotal || subtotal : subtotal;

  const handleOpenCurrentCart = React.useCallback(() => {
    rootReplace("Cart", {});
  }, []);

  const handleOpenHistoryOrder = React.useCallback((orderId: string) => {
    rootReplace("Cart", {
      history: true,
      orderId,
    });
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <CartHistoryFloatingPanel
      scaleAll={scaleAll}
      orders={historyOrders}
      showDiscountPrices={showDiscountPrices}
      selectedOrderId={selectedOrderId}
      isHistoryMode={isHistoryMode}
      currentOrderQuantity={totalQuantity}
      currentOrderItemsCount={uniqueItemsCount}
      currentOrderTotal={currentOrderTotal}
      onOpenCurrentCart={handleOpenCurrentCart}
      onOpenHistoryOrder={handleOpenHistoryOrder}
    />
  );
};

export default React.memo(CartHistoryFloatingHost);
